import { hydrate } from 'preact';
import type { ComponentType } from 'preact';

export interface IslandProps {
  id: string;
  component: ComponentType<any>;
  props?: Record<string, any>;
}

export function Island({ id, component: Component, props = {} }: IslandProps) {
  return <Component {...props} />;
}

// Registry for island components
const ISLAND_REGISTRY = new Map<string, ComponentType<any>>();

export function registerIsland(name: string, component: ComponentType<any>) {
  ISLAND_REGISTRY.set(name, component);
}

export function getIsland(name: string): ComponentType<any> | undefined {
  return ISLAND_REGISTRY.get(name);
}

// Client-side hydration function
export function hydrateIsland(elementId: string, componentName: string, props: any = {}) {
  if (typeof window === 'undefined') return;
  
  const element = document.getElementById(elementId);
  const Component = getIsland(componentName);
  
  if (element && Component) {
    hydrate(<Component {...props} />, element);
  }
}

// Auto-hydration for islands marked with data attributes
export function autoHydrateIslands() {
  if (typeof window === 'undefined') return;
  
  document.addEventListener('DOMContentLoaded', () => {
    const islands = document.querySelectorAll('[data-island]');
    
    islands.forEach((element) => {
      const componentName = element.getAttribute('data-island');
      const propsScript = element.querySelector('script[type="application/json"]');
      
      if (componentName) {
        let props = {};
        if (propsScript?.textContent) {
          try {
            props = JSON.parse(propsScript.textContent);
          } catch (e) {
            console.warn('Failed to parse island props:', e);
          }
        }
        
        hydrateIsland(element.id, componentName, props);
      }
    });
  });
}